import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiSlice } from "./apiSlice";
import { RootState } from "../../store/store";
import { Me } from "../types";

interface AuthState {
  user: Me | null;
  loading: boolean;
  initialized: boolean;
}

const initialState: AuthState = {
  user: null,
  loading: false,
  initialized: false,
};

export const fetchMe = createAsyncThunk(
  "auth/fetchMe",
  async (_, { dispatch }) => {
    try {
      const result = await dispatch(
        apiSlice.endpoints.getMe.initiate()
      ).unwrap();
      return result;
    } catch {
      return null;
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    clearUser: (state) => {
      state.user = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMe.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMe.fulfilled, (state, action) => {
        state.user = action.payload;
        state.loading = false;
        state.initialized = true;
      })
      .addCase(fetchMe.rejected, (state) => {
        state.user = null;
        state.loading = false;
        state.initialized = true;
      });
  },
});

export const selectFullName = (state: RootState): string => {
  const user = state.auth.user;
  if (!user) return "Гость";

  const lastName = user.lastName || "";
  const firstName = user.name || "";
  const patronymic = user.patronymic || "";

  const full = `${lastName} ${firstName} ${patronymic}`.trim();
  return full || "Пользователь";
};

export const { setUser, clearUser } = authSlice.actions;
export default authSlice.reducer;
